import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'
import * as Sentry from "@sentry/browser";

import ContextProvider from "context/ContextProvider";
import config from "config";

if (config.environment !== "develop")
    Sentry.init({
        environment: config.environment,
        release: `sw-web-editor@${config.version}`,
        dsn: "https://08edf4ea765649a2a0a4cedbd063c32b@sentry.io/5271331",
        debug: config.environment !== "production"
    });

ReactDOM.render(
    <ContextProvider>
        <App/>
    </ContextProvider>,
    document.getElementById('root')
);